module.exports = __webpack_public_path__ + "static/media/minecomom_old.20f396c6.png";